import { render, staticRenderFns } from "./Grid4.vue?vue&type=template&id=ddb2dc12&scoped=true"
import script from "./Grid4.vue?vue&type=script&lang=ts"
export * from "./Grid4.vue?vue&type=script&lang=ts"
import style0 from "./Grid4.vue?vue&type=style&index=0&id=ddb2dc12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb2dc12",
  null
  
)

export default component.exports